<template>
  <modal
    name="property-details-edit"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="1050"
    height="auto"
    :clickToClose="false"
  >
    <div class="modalWrapper">
      <div class="form-row mb-4">
        <div class="col-md-6">
          <div class="content__box h-100">
            <div class="content__box__body">
              <p class="txt--ss txt--semi-bold txt--off-white mb-3">
                {{ $t("Details") }}
              </p>
              <div class="form-group">
                <label class="txt--ss txt--off-white mb-2">
                  {{ $t("property_name") }}
                </label>

                <input
                  type="text"
                  name="property_name"
                  id="property_name"
                  class="textInputField"
                  v-model="property_name"
                />
              </div>
              <div class="form-group">
                <label class="txt--ss txt--off-white mb-2">{{
                  $t("Number_of_Spaces")
                }}</label>
                <!-- Modified p tag to label -->
                <input
                  type="number"
                  min="0"
                  name="quantity"
                  id="quantity"
                  @keyup="checkNumber;quantityChange(quantity);"
                  class="textInputField"
                  v-model="quantity"
                  :maxlength=4
                />
              </div>

              <div class="form-group"
               v-for="(type,index) in space_type" :key="index"
              >
                <div class="d-flex justify-content-between">
                  <label
                    class="txt--ss txt--off-white mb-2"
                    :label="type.name"
                  >
                   {{type.name}}
                  </label>
                  <p class="txt--fsxs cursor-pointer opacity--25 mb-2"
                  @click="removeSpacetypes(index)"
                  >
                    Delete
                  </p>
                </div>
                <input
                  type="number"
                  min="0"
                  class="textInputField"
                  v-model.number="space_type[index].quantity"
                />
              </div>
              <p class="txt--fsxs cursor-pointer opacity--25 mb-4"
               @click="addSpacetype">
                + Add type of spaces
              </p>
              <div class="mb-4">
                <Text-area
                  label="Description"
                  v-model="description"
                  :value="description"
                  :rows="5"
                  :char_limit="500"
                />
              </div>
              <div class="mb-4">
                <Text-area
                  label="Access Instructions (optional)"
                  v-model="access_instruction"
                  :value="access_instruction"
                  :rows="3"
                />
              </div>
              <div class="mb-4">
                <Text-area
                  label="Restrictions - height restrictions, overnight parking, etc. (optional)"
                  placeholder="Type here..."
                  :rows="3"
                  v-model="restrictions"
                  :value="restrictions"
                />
              </div>
              <div class="form-group">
                <label class="txt--ss txt--off-white m4-2">{{
                  $t("Custom_Text")
                }}</label>
                <input
                  type="text"
                  name="custom_text"
                  id="custom_text"
                  class="textInputField"
                  v-model="customText"
                />
              </div>
              <div class="row align-items-center">
                <div class="col-sm-5">
                  <app-toggle
                    :checked="height_restriction_status"
                    @update:checked="
                      getCheckedStatus($event, 'height_restriction')
                    "
                    label="Height Restrictions"
                  ></app-toggle>
                </div>
                <div
                  class="col-sm-7 mt-4 mt-sm-0"
                  v-if="height_restriction_status"
                >
                  <div
                    class="form-row mb-1"
                    v-for="(r, index) in height_restriction"
                    :key="index"
                  >
                    <div class="col-3">
                      <div class="d-flex align-items-center">
                        <p class="txt--off-white txt--xs">Levels</p>
                        <input
                          type="text"
                          class="hidden_input hidden_input__md ml-1"
                          min="0"
                          v-model="r.level"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="d-flex h-100 align-items-center">
                        <p class="txt--off-white txt--xs mr-1">Height</p>
                        <!-- <input
                          type="text"
                          class="hidden_input hidden_input__md ml-1"
                          v-model="r.height"
                          @keypress="validateHeight($event,index)"
                        /> -->
                        <p
                          class="txt--primary txt--xs cursor-pointer"
                          @click="editHeightRestriction(r, index)"
                        >
                          {{ r.height }}
                        </p>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="d-flex align-items-center h-100">
                        <p
                          class="opacity--25 cursor-pointer txt--xs"
                          v-if="index != 0"
                          @click="removeRestriction(index)"
                        >
                          {{ $t("Remove") }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <p
                        class="opacity--25 cursor-pointer txt--xs"
                        @click="addMoreRestriction()"
                      >
                        {{ $t("Add_More") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mt-4">
                  <app-toggle
                    :checked="oversized_vehicles"
                    @update:checked="
                      getCheckedStatus($event, 'oversized_vehicle')
                    "
                    label="Oversized Vehicles"
                  ></app-toggle>
                </div>
                <div class="col-sm-12 mt-4">
                  <app-toggle
                    :checked="control_gates"
                    @update:checked="
                      getCheckedStatus($event, 'control_gates')
                    "
                    label="Control Gates"
                  ></app-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-4 mt-md-0">
          <div class="content__box mb-3">
            <div class="content__box__body">
              <p class="txt--ss txt--semi-bold txt--off-white mb-3">
                {{ $t("Amenities") }}
              </p>
              <div class="row">
                <div
                  class="col-sm-4 mb-3"
                  v-for="(am, index) in amenity"
                  :key="index"
                >
                  <app-toggle
                    :checked="checkAmenitySelected(am.id)"
                    v-model="selected_amenity"
                    :label="am.title"
                    @update:checked="getSelectedAmenity($event, am.id)"
                  ></app-toggle>
                </div>
              </div>
            </div>
          </div>
          <div class="content__box">
            <div class="content__box__body">
              <div class="mb-3">
                <p class="txt--ss txt--semi-bold txt--off-white mb-2">
                  {{ $t("Address") }}
                </p>
                <gmap-autocomplete
                  class="textInputField"
                  :value="address"
                  @place_changed="getAddress"
                  :options="googleMapOption"
                  :types="['address']"
                ></gmap-autocomplete>
              </div>
              <div>
                <div class="mb-2">
                  <a
                    href="javascript:void(0);"
                    class="txt--primary txt--ss"
                    @click="addMoreAddress"
                    >Add Entrance Address</a
                  >
                </div>

                <div class="entrance__address pr-2 mb-2" id="entrance_address">
                  <div
                    class="mt-2"
                    v-for="(e, index) in optional_address_arr"
                    :key="index"
                  >
                    <p class="txt--xs txt--off-white mb-2">
                      <span class="txt--semi-bold"
                        >Entrance Address #{{ index + 1 }}</span
                      >
                      (optional: if different from property address)
                    </p>
                    <gmap-autocomplete
                      class="textInputField"
                      :value="optional_address_arr[index]"
                      @place_changed="getEntranceAddress($event, index)"
                      :options="googleMapOption"
                      :types="['address']"
                    ></gmap-autocomplete>
                    <div class="text-right">
                      <a
                        href="javascript:void(0);"
                        class="txt--primary txt--xs"
                        @click="removeAddress(index)"
                      >
                        Remove</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="propertyAddress">
                <div
                  class="
                    d-flex
                    flex-wrap
                    align-items-center
                    justify-content-between
                  "
                >
                  <p class="txt--xs txt--off-white my-2">
                    Or drag entrance map marker to the entrance location
                  </p>
                  <ul class="list-unstyled propertyAddress__tab my-2">
                    <li
                      :class="{ active: mapVariant === 'map' }"
                      @click="mapType('map')"
                    >
                      Map
                    </li>
                    <li
                      class="ml-3"
                      :class="{ active: mapVariant === 'streetview' }"
                      @click="mapType('streetview')"
                    >
                      Street View
                    </li>
                  </ul>
                </div>

                <div class="propertyAddress__map">
                  <propertyMap
                    v-if="mapVariant === 'map'"
                    :location="location"
                    :entrance_location_arr="entrance_location_arr"
                    @entrance:moved="getLatLng($event)"
                  />
                  <streetView
                    v-if="mapVariant === 'streetview'"
                    :street_location="panaroma_coordinates"
                    :pitch="camera_pitch"
                    :zoom="camera_zoom"
                    :heading="camera_heading"
                  ></streetView>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row"
      v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)"
      >
        <div class="col-12">
          <div class="d-flex justify-content-center flex-wrap">
            <button
              type="button"
              class="button button--primary button--sm mr-3"
              @click="submitDetails()"
            >
              Save
            </button>
            <button
              type="button"
              class="button button--outline button--sm"
              @click="closeModal()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import Toggle from "@/components/toggle";
import Textarea from "@/components/Textarea";
import propertyMap from "@/components/propertyMap";
import streetView from "@/components/streetView.vue";

export default {
  name: "EditProperty",
  props: ["property_details", "amenity"],
  data() {
    return {
      space_id: null,
      toggleActive: false,
      selected_amenity: [],
      totalRequest:0,
      quantity: 0,
      customText: '',
      space_type:[
      ],
      // space_type_quantity:[],
      property_name: "", // new field add for property_name,it was splited from address array previously
      description: "",
      access_instruction: "",
      restrictions: "",
      height_restriction_status: false,
      oversized_vehicles: false,
      control_gates: false,
      height: `8'2"`,
      height_units_big: ["m", "ft"],
      height_units_small: ["cm", "inch"],
      height_restriction_static_values: [
        {
          level: 1,
          height_1: 8,
          height_1_unit: "ft",
          height_2: 7,
          height_2_unit: "inch",
          height: "8 ft 7 inch",
          height_in_cm: 261.62,
        },
      ],
      height_restriction: [],
      address: "",
      city: "",
      // optional_address: "",
      optional_address_arr: [],
      location: {
        lat: null,
        lng: null,
      },
      // entrance_location: {
      //   lat: null,
      //   lng: null,
      // },
      entrance_location_arr: [],
      street_view: null,
      street_view_not_found: false,
      time_zone: "",
      place_id: "",
      pano_id: "",
      camera_fov: "",
      panaroma_coordinates: {
        lat: null,
        lng: null,
      },
      camera_pitch: "",
      camera_zoom: "",
      camera_heading: 0,
      panoramaView: null,
      mapVariant: "map",
      googleMapOption: {
        types: ["address"],
      },
      user_role:    '',
      access_list:  {},
    };
  },
  components: {
    AppToggle: Toggle,
    "Text-area": Textarea,
    propertyMap: propertyMap,
    streetView: streetView,
  },
  created() {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list"));

    //populate space id
    this.space_id = this.property_details.space_id;
    //populate selected amenity list
    this.selected_amenity = this.property_details.details.amenities;
    //populate quantity of the property
    this.quantity = this.property_details.details.quantity;
    this.customText = this.property_details.details.custom_text;
    //populate Name of the property
    this.property_name =
      this.property_details.details.property_name != ""
        ? this.property_details.details.property_name
        : this.property_details.location.address.split(",")[0];
    //alert(this.property_name);

    // Quantity  distribution
    this.space_type=this.property_details.details.quantity_distribution;
    //populate descriptions
    this.description = this.property_details.details.description;
    //populate access instruction
    this.access_instruction = this.property_details.details.access_instruction;
    //populate restrictions
    this.restrictions = this.property_details.details.restrictions;
    //populate oversized vehicle
    this.oversized_vehicles =
      this.property_details.details.oversized_vehicle == 1 ? true : false;
    //conrol gates status
    this.control_gates =
      this.property_details.control_gates == 1 ? true : false;
    //populate height restriction
    this.height_restriction_status =
      this.property_details.details.height_restriction.length > 0
        ? true
        : false;
    if (!this.height_restriction_status) {
      this.height_restriction.push(this.height_restriction_static_values[0]);
    } else {
      this.height_restriction =
        this.property_details.details.height_restriction;
      //============= Support For Old Height Restriction ===============//
      this.height_restriction.map((value) => {
        value.height = value.height.replace("'", " ft ");
        value.height = value.height.replace('"', " inch ");

        let h1 =
          value.height.indexOf("ft") != -1 ? value.height.split("ft")[0] : 0;
        let h1_unit = "ft";
        let h2_unit = "inch";
        let h2 =
          value.height.indexOf("inch") != -1
            ? value.height.split("inch")[0]
            : 0;
        if (h2) {
          h2 = h2.indexOf("ft") != -1 ? h2.split("ft")[1] : h2;
        }
        if (h1 <= 0 && h2 <= 0) {
          h2 = parseInt(value.height);
        }
        value.height_1 = parseInt(h1);
        value.height_1_unit = h1_unit;
        value.height_2 = parseInt(h2);
        value.height_2_unit = h2_unit;
        let height_1_cm =
          h1_unit == "ft"
            ? parseInt(h1 * 30.48)
            : h1_unit == "m"
            ? parseInt(h1 * 100)
            : parseInt(h1);
        let height_2_cm =
          h2_unit == "inch" ? parseInt(h2 * 2.54) : parseInt(h2);

        let total_height_cm = height_1_cm + height_2_cm;
        value.height_in_cm = total_height_cm;
      });
    }


    //populate address
    this.address = this.property_details.location.address;
    //populate optional address
    // this.optional_address = this.property_details.location.entrance_address
    //   ? this.property_details.location.entrance_address
    //   : "";
    //populate lat and long
    this.location.lat = this.property_details.location.latitude;
    this.location.lng = this.property_details.location.longitude;
    //populate entrance lat and lng
    // this.entrance_location.lat = this.property_details.location
    //   .entrance_latitude
    //   ? this.property_details.location.entrance_latitude
    //   : this.location.lat;
    // this.entrance_location.lng = this.property_details.location
    //   .entrance_longitude
    //   ? this.property_details.location.entrance_longitude
    //   : this.location.lng;

    if (this.property_details.location.entrance_address_details.length > 0) {
      this.property_details.location.entrance_address_details.map((val) => {
        this.optional_address_arr.push(val.formatted_address);
        this.entrance_location_arr.push({
          lat: val.lat,
          lng: val.lng,
        });
      });
    }

    //populate timezone
    this.time_zone = this.property_details.location.time_zone;
    //populate place_id
    this.place_id = this.property_details.location.place_id;
    //populate city
    this.city = this.property_details.location.city;
    //populate panaroma id
    this.pano_id = this.property_details.location.pano_id;
    //populate camera fov
    this.camera_fov = this.property_details.location.camera_fov;
    //populate camera pitch
    this.camera_pitch = this.property_details.location.camera_pitch;
    //populate camera zoom
    this.camera_zoom = this.property_details.location.camera_zoom;
    //populate camera heading
    this.camera_heading = this.property_details.location.camera_heading
      ? this.property_details.location.camera_heading
      : 0;
    //populate panarom coordinates

    this.panaroma_coordinates.lat = this.property_details.location
      .panorama_latitude
      ? this.property_details.location.panorama_latitude
      : null;
    this.panaroma_coordinates.lng = this.property_details.location
      .panorama_longitude
      ? this.property_details.location.panorama_longitude
      : null;
    if (
      this.property_details.location.panorama_latitude == "" ||
      this.property_details.location.panorama_latitude == null
    ) {
      this.street_view_not_found = true;
      this.street_view_found = false;
    }
  },
  computed: {
    computeModalWidth() {
      if (this.$mq === "lg") return "900px";
      else return "400px";
    },
  },
  methods: {
    async mapType(map) {
      if (map === "streetview") {
        this.street_view = new window.google.maps.StreetViewService();
        const self = this;
        let myLatlng = new window.google.maps.LatLng(
          this.panaroma_coordinates.lat,
          this.panaroma_coordinates.lng
        );
        await this.street_view.getPanorama(
          {
            location: myLatlng,
            radius: 100,
            source: window.google.maps.StreetViewSource.OUTDOOR,
          },
          function (data, status) {
            // console.log(
            //   "outdoor",
            //   data,
            //   status,
            //   window.google.maps.StreetViewStatus.OK
            // );
            if (status == window.google.maps.StreetViewStatus.OK) {
              self.street_view_not_found = false;
              self.location.lat = data.location.latLng.lat();
              self.location.lng = data.location.latLng.lng();
              self.getPanoramaDetails();
              self.mapVariant = map;
            } else {
              self.street_view_not_found = true;
              self.panaroma_coordinates.lat = null;
              self.panaroma_coordinates.lng = null;

              self.$toasted.show(
                "No outdoor street view found! Please choose a different address",
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
            }

            // self.getPanoramaDetails();
          }
        );
      } else {
        this.mapVariant = map;
      }
    },
    closeModal() {
      this.$emit("modal_closed");
      this.$modal.hide("property-details-edit");
    },
    checkAmenitySelected(amenity_id) {
      if (this.property_details.details.amenities.indexOf(amenity_id) != -1) {
        return true;
      } else {
        return false;
      }
    },
    getSelectedAmenity(checked, amenity_id) {
      if (checked) {
        this.selected_amenity.push(amenity_id);
      } else {
        this.$delete(
          this.selected_amenity,
          this.selected_amenity.indexOf(amenity_id)
        );
      }
    },
    getCheckedStatus(checked, type) {
      if (type == "height_restriction") {
        this.height_restriction_status = checked;
        if (!checked) {
          this.height_restriction = [];
          this.height_restriction.push(
            this.height_restriction_static_values[0]
          );
        }
      } else if (type == "oversized_vehicle") {
        this.oversized_vehicles = checked;
      }else if (type == "control_gates") {
        this.control_gates = checked;
      }
    },
    quantityChange(q) {
      if (isNaN(parseInt(q))) {
        this.quantity = 0;
      }

      if (q < 0) {
        this.quantity = 0;
      }
     
    },
    checkNumber(evt) {
      evt = evt ? evt : window.event;
      //var charCode = evt.which ? evt.which : evt.keyCode;
      //if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
      //} else {
      return true;
      // }
    },
    addMoreRestriction() {
      let new_height = {};
      // new_height.level =
      //   parseInt(
      //     this.height_restriction[this.height_restriction.length - 1].level
      //   ) + 1;
      // new_height.height_1 = Math.floor(Math.random() * 10) + 1;
      // new_height.height_1_unit = this.height_restriction[
      //   this.height_restriction.length - 1
      // ].height_1_unit;
      // new_height.height_2 = Math.floor(Math.random() * 10) + 1;
      // new_height.height_2_unit = this.height_restriction[
      //   this.height_restriction.length - 1
      // ].height_2_unit;
      // new_height.height =
      //   new_height.height_1 +
      //   " " +
      //   new_height.height_1_unit +
      //   " " +
      //   new_height.height_2 +
      //   " " +
      //   new_height.height_2_unit;
      new_height = JSON.parse(
        JSON.stringify(
          this.height_restriction[this.height_restriction.length - 1]
        )
      );
      let levelVariable = new_height.level;
      let checkNumber = /^-?[\d.]+(?:e-?\d+)?$/;

      if (checkNumber.test(levelVariable)) {
        new_height.level =
          parseInt(
            this.height_restriction[this.height_restriction.length - 1].level
          ) + 1;
      } else {
        new_height.level =
          this.height_restriction[this.height_restriction.length - 1].level;
      }

      this.height_restriction.push(new_height);
    },
    removeRestriction(index) {
      this.$delete(this.height_restriction, index);
    },
    async editHeightRestriction(height, index) {
      let options_1 = "";
      this.height_units_big.map(function (v) {
        if (height.height_1_unit == v) {
          options_1 = options_1 + `<option value="${v}" selected>${v}</option>`;
        } else {
          options_1 = options_1 + `<option value="${v}">${v}</option>`;
        }
      });
      let options_2 = "";
      this.height_units_small.map(function (v) {
        if (height.height_2_unit == v) {
          options_2 = options_2 + `<option value="${v}" selected>${v}</option>`;
        } else {
          options_2 = options_2 + `<option value="${v}">${v}</option>`;
        }
      });

      const { value: height_restriction } = await this.$swal({
        title: "Enter Height Restriction",
        html: `<div class="row justify-content-center">
            <div class="col-sm-6">
              <div class="d-flex justify-content-center align-items-center">
                <p class="txt--xs txt--off-white">Height:</p>
                <input type="number" placeholder="Height" class="hidden_input hidden_input__lg " min="0" id="swal-height_1" value="${height.height_1}">
                <select id="swal-height_1_unit" class="hidden_input hidden_input__lg ">
                  ${options_1}
                </select>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="d-flex justify-content-center align-items-center">
                <input type="number" placeholder="Height" class="hidden_input hidden_input__lg " min="0" id="swal-height_2" value="${height.height_2}">
                <select id="swal-height_2_unit" class="hidden_input hidden_input__lg ">
                  ${options_2}
                </select>
              </div>
            </div>
          </div>`,
        showCancelButton: true,
        preConfirm: () => {
          var height_1 = parseInt(
            document.getElementById("swal-height_1").value
          );
          var height_1_unit =
            document.getElementById("swal-height_1_unit").value;
          var height_2 = parseInt(
            document.getElementById("swal-height_2").value
          );
          var height_2_unit =
            document.getElementById("swal-height_2_unit").value;

          if (isNaN(height_1) && isNaN(height_2)) {
            this.$toasted.show("Height is required!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          } else if (height_1 == 0 && isNaN(height_2)) {
            this.$toasted.show("height can not be zero!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          } else if (height_2 == 0 && isNaN(height_1)) {
            this.$toasted.show("height can not be zero!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          } else if (height_1 == 0 && height_2 == 0) {
            this.$toasted.show("height can not be zero!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          } else {
            //============== Height Unit check ===============//
            if (height_1_unit == "" || height_2_unit == "") {
              this.$toasted.show("Height unit is required!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (height_1_unit == height_2_unit) {
              this.$toasted.show("Height units can not be the same!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (height_1_unit == "m" && height_2_unit == "inch") {
              this.$toasted.show("Height units are not valid!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else if (height_1_unit == "ft" && height_2_unit == "cm") {
              this.$toasted.show("Height units are not valid!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            } else {
              if (height_2_unit == "cm" && height_2 > 999) {
                this.$toasted.show("Height is invalid!", {
                  icon: "times-circle",
                  className: "error-class",
                });
                return false;
              }
              if (height_2_unit == "inch" && height_2 > 11) {
                this.$toasted.show("Height is invalid!", {
                  icon: "times-circle",
                  className: "error-class",
                });
                return false;
              }
              if (height_1_unit > 100) {
                this.$toasted.show("Height is invalid!", {
                  icon: "times-circle",
                  className: "error-class",
                });
                return false;
              }
              return {
                height_1: height_1,
                height_2: height_2,
                height_1_unit: height_1_unit,
                height_2_unit: height_2_unit,
              };
            }
          }
        },
      });
      if (height_restriction != undefined) {
        this.height_restriction[index].height_1 = height_restriction.height_1
          ? height_restriction.height_1
          : 0;
        this.height_restriction[index].height_1_unit =
          height_restriction.height_1_unit
            ? height_restriction.height_1_unit
            : "";
        this.height_restriction[index].height_2 = height_restriction.height_2
          ? height_restriction.height_2
          : 0;
        this.height_restriction[index].height_2_unit =
          height_restriction.height_2_unit
            ? height_restriction.height_2_unit
            : "";
        this.height_restriction[index].height = "";
        if (this.height_restriction[index].height_1 > 0) {
          this.height_restriction[index].height =
            this.height_restriction[index].height +
            this.height_restriction[index].height_1 +
            " " +
            this.height_restriction[index].height_1_unit +
            " ";
        }
        if (this.height_restriction[index].height_2 > 0) {
          this.height_restriction[index].height =
            this.height_restriction[index].height +
            this.height_restriction[index].height_2 +
            " " +
            this.height_restriction[index].height_2_unit;
        }
      }
    },
    showFormattedHeight(height) {
      let height_string =
        height.height_1 != ""
          ? height.height_1 + " " + height.height_1_unit
          : "";
      height_string =
        height.height_2 != ""
          ? height_string + " " + height.height_2 + " " + height.height_2_unit
          : "" + height_string + "";
      return height_string;
    },
    validateHeight(evt, index) {
      evt = evt ? evt : window.event;

      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 39 &&
        charCode !== 34
      ) {
        evt.preventDefault();
      } else {
        //check if first character is single quote or double quote
        if (this.height_restrict[index].height.length == 0) {
          if (charCode === 39) {
            evt.preventDefault();
          }
          if (charCode === 34) {
            evt.preventDefault();
          }
        }
        //check if single quote already present or not
        if (this.height_restrict[index].height.indexOf("'") != -1) {
          if (charCode === 39) {
            evt.preventDefault();
          }
        }
        //check if double quote already present or not
        if (this.height_restrict[index].height.indexOf('"') != -1) {
          evt.preventDefault();
        }
        return true;
      }
    },
    validateHeightRegex(index) {
      var regex = "^(?!$|.*'[^\x22]+$)(?:([0-9]+)')?(?:([0-9]+)\x22?)?$";
      if (this.height_restrict[index].height.match(regex)) {
        return true;
      } else {
        this.$toasted.error("Invalid height");
      }
    },
    async getAddress(place) {
      if (place.formatted_address) {
        this.city = place.vicinity;
        this.place_id = place.place_id;
        this.address = place.formatted_address;
        // this.optional_address = place.formatted_address;
        this.location.lat = place.geometry.location.lat();
        this.location.lng = place.geometry.location.lng();
        await this.getOutdoorStreetViewLocationForAddress(this.location);
        this.getTimeZone();
      } else {
        this.$toasted.show("Invalid address", {
          icon: "times-circle",
          className: "error-class",
        });
      }
    },
    async getEntranceAddress(place, index) {
      if (place.formatted_address) {
        this.city = this.city == "" ? place.vicinity : this.city;
        this.place_id = this.place_id == "" ? place.place_id : this.place_id;
        this.optional_address_arr[index] = place.formatted_address;
        // this.entrance_location.lat = place.geometry.location.lat();
        // this.entrance_location.lng = place.geometry.location.lng();
        this.entrance_location_arr[index].lat = place.geometry.location.lat();
        this.entrance_location_arr[index].lng = place.geometry.location.lng();
        await this.getOutdoorStreetViewLocation(index);
        this.getTimeZone();
      } else {
        this.$toasted.show("Invalid address", {
          icon: "times-circle",
          className: "error-class",
        });
      }
    },
    getTimeZone() {
      this.axios
        .get(
          `https://maps.googleapis.com/maps/api/timezone/json?location=${this.location.lat},${this.location.lng}
      &timestamp=0&key=AIzaSyBTeSQpeOJb1KVmT8Dp0lmUnQ3ZAvvO6xI`
        )
        .then((res) => {
          this.time_zone = res.data.timeZoneId;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLatLng(event) {
      this.entrance_location_arr[event.index].lat = event.coordinates.lat;
      this.entrance_location_arr[event.index].lng = event.coordinates.lng;
      if (this.time_zone == "") {
        this.getTimeZone();
      }
      // this.getOutdoorStreetViewLocation(event.index);
      this.street_view_not_found = !event.street_view_found;
      if (this.address != "") {
        this.$set(
          this.optional_address_arr,
          event.index,
          event.formatted_address
        );
      } else {
        this.$set(
          this.optional_address_arr,
          event.index,
          event.formatted_address
        );
        this.address = this.optional_address_arr[0];
      }
      if (event.street_view_found) {
        this.street_view_not_found = false;
      } else {
        this.street_view_not_found = true;
      }
      if (event.place_id && this.place_id == "") {
        this.place_id = event.place_id;
      }
      if (event.city && this.city == "") {
        this.city = event.city;
      }
    },
    async getOutdoorStreetViewLocationForAddress(location) {
      this.street_view = new window.google.maps.StreetViewService();
      const self = this;
      let myLatlng = new window.google.maps.LatLng(location.lat, location.lng);
      await this.street_view.getPanorama(
        {
          location: myLatlng,
          radius: 100,
          source: window.google.maps.StreetViewSource.OUTDOOR,
        },
        function (data, status) {
          // console.log(
          //   "outdoor",
          //   data,
          //   status,
          //   window.google.maps.StreetViewStatus.OK
          // );
          if (status == window.google.maps.StreetViewStatus.OK) {
            self.street_view_not_found = false;
            self.location.lat = data.location.latLng.lat();
            self.location.lng = data.location.latLng.lng();
            self.getPanoramaDetails();
          } else {
            self.street_view_not_found = true;
            self.location.lat = null;
            self.location.lng = null;
            self.$toasted.show(
              "No outdoor street view found! Please choose a different address",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
          }
        }
      );
    },
    async getOutdoorStreetViewLocation(index) {
      let location = this.entrance_location_arr[index];
      this.street_view = new window.google.maps.StreetViewService();
      const self = this;
      let myLatlng = new window.google.maps.LatLng(location.lat, location.lng);
      await this.street_view.getPanorama(
        {
          location: myLatlng,
          radius: 100,
          source: window.google.maps.StreetViewSource.OUTDOOR,
        },
        function (data, status) {
          if (status == window.google.maps.StreetViewStatus.OK) {
            self.street_view_not_found = false;
            location.lat = data.location.latLng.lat();
            location.lng = data.location.latLng.lng();
            if (
              self.panaroma_coordinates.lat == null &&
              self.panaroma_coordinates.lng == null
            ) {
              self.panaroma_coordinates.lat = location.lat;
              self.panaroma_coordinates.lng = location.lng;
            }
          } else {
            self.street_view_not_found = true;
            location.lat = null;
            location.lng = null;
            self.$toasted.show(
              "No outdoor street view found! Please choose a different address",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
          }
        }
      );
    },
    getPanoramaDetails() {
      this.axios
        .get(
          `https://maps.googleapis.com/maps/api/streetview/metadata?location=${this.location.lat},${this.location.lng}&key=AIzaSyBTeSQpeOJb1KVmT8Dp0lmUnQ3ZAvvO6xI`
        )
        .then((res) => {
          this.pano_id = res.data.pano_id;
          this.panaroma_coordinates.lat = res.data.location.lat;
          this.panaroma_coordinates.lng = res.data.location.lng;
        });
    },
    submitDetails() {
      //----------- Street View ----------------------//
      // this.mapType('streetview');
      this.totalRequest= this.space_type.reduce((total, obj) => obj.quantity + total,0);
      if (this.street_view_not_found) {
        this.$toasted.show(
          "Street view not found for this address! Please choose another address",
          {
            icon: "times-circle",
            className: "error-class",
          }
        );
      } else {
        //---------- empty validation check ----------//
        if (this.quantity == 0) {
          this.$toasted.show("Quantity can not be 0", {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
        }
        if(this.quantity.length>4){
          this.$toasted.show("Please provide valid Quantity", {
            icon: "times-circle",
            className: "error-class",
          });
          return false;        
        }

   

        if (this.description == "") {
          this.$toasted.show("Description is required", {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
        }
        if (this.property_name == "") {
          this.$toasted.show("Property Name is required", {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
        }
        if (this.address == "") {
          this.$toasted.show("Address is required", {
            icon: "times-circle",
            className: "error-class",
          });
          return false;
        }
        let entrance_address_details = [];
        if (this.optional_address_arr.length > 0) {
          this.optional_address_arr.map((val, key) => {
            entrance_address_details.push({
              formatted_address: val,
              lat: this.entrance_location_arr[key].lat,
              lng: this.entrance_location_arr[key].lng,
            });
          });
        }
    
        if(this.totalRequest>this.quantity){
           this.$toasted.show("Total space type cannot be more than number of spaces", {
            icon: "times-circle",
            className: "error-class",
        });
        return false;
        }
        this.axios
          .post(window.hostname + "api/auth/create-space", {
            device_type: 1,
            mode: "all-details",
            space_id: this.space_id,
            quantity: this.quantity,
            custom_text: this.customText,
            property_name: this.property_name,
            amenities: this.selected_amenity,
            access_instruction: this.access_instruction,
            description: this.description,
            restrictions: this.restrictions,
            // entrance_address: this.optional_address,
            // entrance_latitude: this.location.lat,
            // entrance_longitude: this.location.lng,
            entrance_address_details: entrance_address_details,
            height_restriction: this.height_restriction_status
              ? this.height_restriction
              : [],
            oversized_vehicle: this.oversized_vehicles ? 1 : 0,
            control_gates:this.control_gates ? 1 : 0,
            address: this.address,
            city: this.city,
            time_zone: this.time_zone,
            place_id: this.place_id,
            latitude: this.location.lat,
            longitude: this.location.lng,
            pano_id: this.pano_id,
            camera_heading: this.camera_heading,
            camera_pitch: this.camera_pitch ? this.camera_pitch : 34,
            camera_zoom: this.camera_zoom ? this.camera_zoom : 1,
            camera_fov: this.camera_fov ? this.camera_fov : 90,
            panorama_latitude: this.panaroma_coordinates.lat,
            panorama_longitude: this.panaroma_coordinates.lng,
            space_distribution:this.space_type,
            commercial: 1,
          })
          .then((res) => {
            if (res.data.status) {
              //alert(window.hostname + "api/auth/create-space");
              this.$toasted.show("Property details updated successfully!", {
                icon: "check-circle",
                className: "success-class",
              });
              this.closeModal();
            } else {
              this.$toasted.show("Something went wrong. Please try again!", {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.$toasted.show("Something went wrong. Please try again!", {
              icon: "times-circle",
              className: "error-class",
            });
          });
      }
    },
    /**
     * Add Entrance Address
     */
    addMoreAddress() {
      if (this.address == "") {
        this.$toasted.show("Please add a default address for the property!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.optional_address_arr.length > 0) {
        this.optional_address_arr.push(
          JSON.parse(
            JSON.stringify(
              this.optional_address_arr[this.optional_address_arr.length - 1]
            )
          )
        );
        this.entrance_location_arr.push(
          JSON.parse(
            JSON.stringify(
              this.entrance_location_arr[this.entrance_location_arr.length - 1]
            )
          )
        );
      } else {
        this.optional_address_arr.push(
          JSON.parse(JSON.stringify(this.address))
        );
        this.entrance_location_arr.push(
          JSON.parse(JSON.stringify(this.location))
        );
      }

      var div = document.getElementById("entrance_address");
      this.$nextTick(() => {
        div.scrollTop = div.scrollHeight - div.clientHeight;
      });
    },
    /**
     * Remove Entrance Address
     */
    removeAddress(index) {
      this.$delete(this.optional_address_arr, index);
      this.$delete(this.entrance_location_arr, index);
    },

    addSpacetype(){
      // return false;
      let spaceTypes= this.$swal({
        title: "Special Event Name",
        input: "text",
        inputValue: `Space types ${this.space_type.length +1}`,
        inputPlaceholder: "Enter Space types",
        showCancelButton: true,
        preConfirm: (value) => {
          console.log(value);
          if (!value) {
            this.$toasted.show("Please enter a Space types!", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          }
          else{
              this.space_type.push(
               {
                 name:value,
                 quantity:0
                }
              );
          }
        },
      });
    },
    removeSpacetypes(index){
      this.$delete(this.space_type,index);
    }
  },
};
</script>

<style>
.vm--overlay {
  background: rgba(10, 10, 10, 0.9) !important;
}
/* STYLE  */
</style>
